module.exports = __webpack_public_path__ + "static/media/back.c339c3d5.png";